export default __webpack_public_path__ + "static/b_radler_03-6b9cd7b62cfcf40e9f9db02e9db872aa.png";